import MapiCookies from "./modules/MapiCookies";
import MapiTabs from "./modules/MapiTabs";
import MapiAccordion from "./modules/MapiAccordion";
import MapiToggleCookieModal from "./modules/MapiToggleCookieModal";

MapiCookies();

MapiTabs();
MapiAccordion();

const widgetButton = document.getElementById('MapiCookieOpenWidget');

if (widgetButton){
    widgetButton.addEventListener('click', function () {
       MapiToggleCookieModal('show');
    });
}